
<div v-resize="onResize">
    <p-order-editor
        v-if    = "selected"
        v-model = "edit"
        :order  = "selected"
        @stored = "onRefresh"
    />

    <v-expansion-panels accordion flat class="mb-1" v-model="expandFilter" style="background-color: transparent" :readonly="prioritize">
        <v-expansion-panel class="pa-0" :key="1" style="background-color: transparent">
            <v-expansion-panel-header :ripple="false" expand-icon="" class="pa-0" style="background-color: white">
                <c-column-header
                    label = "Aufträge"
                    class="primary mt-2"
                    style  = "font-size: 16px; max-width: calc(100% - 16px)"
                >
                    <template v-slot:post>
                        <c-toolbar-button
                            v-if     = "isDisponent"
                            class    = "ml-1"
                            style    = "margin-top: -2px;"
                            :icon    = "prioritize ? 'mdi-stop-circle-outline' : 'mdi-drag'"
                            size     = "24"
                            color    = "white"
                            :tooltip = "prioritize ? $t('disposition.order.prioritize.off') : $t('disposition.order.prioritize.on')"
                            @click   = "onPrioritize"
                        />
                    </template>
                    <template v-slot:toolbar>
                        <c-toolbar-button
                            v-if     = "!prioritize"
                            class    = "mr-3"
                            style    = "margin-top: -2px;"
                            :icon    = "compact ? 'mdi-arrow-collapse-vertical' : 'mdi-arrow-expand-vertical'"
                            size     = "22"
                            color    = "white"
                            :tooltip = "compact ? $t('disposition.order.scope.show') : $t('disposition.order.scope.hide')"
                            @click   = "onCompact"
                        />

                        <c-toolbar-button
                            v-if     = "!prioritize && isDisponent"
                            class    = "mr-3"
                            style    = "margin-top: -2px;"
                            icon     = "mdi-plus"
                            size     = "22"
                            color    = "white"
                            :tooltip = "$t('disposition.order.create')"
                            @click   = "onNewOrder"
                        />

                        <c-toolbar-button
                            v-if     = "!prioritize"
                            class    = "mr-3"
                            style    = "margin-top: -2px;"
                            icon     = "mdi-refresh"
                            size     = "22"
                            color    = "white"
                            :tooltip = "$t('disposition.order.refresh')"
                            @click   = "onRefresh"
                        />
                    </template>

                    <template v-slot:filter>
                        <div class="v-flex" v-if="!prioritize" style="margin-top: -2px">
                            <c-item-count :count="count" :key="count" style="padding-top: 1px;" />
                            <a @click.stop="onFilter" >
                                <v-icon size="18" class="pr-1 white--text">mdi-filter</v-icon>
                            </a>
                            <a @click.stop="onRemoveFilter"  v-if="searchtext">
                                <v-icon size="18" class="pr-1 white--text ">mdi-filter-off-outline</v-icon>
                            </a>
                        </div>
                    </template>
                </c-column-header>
            </v-expansion-panel-header>

            <v-expansion-panel-content
                class = "pa-0 ma-0"
                style = "padding-right: 10px!important;"
                eager
            >
                <div class="lm-border mt-1  mb-1 pa-3 pt-0 " >
                    <div class="pb-1">
                        <v-text-field
                            v-model        = "searchtext"
                            autocomplete   = "off"
                            autocorrect    = "off"
                            autocapitalize = "off"
                            spellcheck     = "false"
                            append-icon    = "fas fa-search"
                            :clearable     = "true"
                            @input         = "onSearch"
                            hide-details
                        />
                    </div>

                    <div class="mb-3">
                        <v-switch
                            :label   = "$t('disposition.order.filter.closed')"
                            v-model  = "filter.showAllOrders"
                            @change  = "onFilter"
                            :ripple  = "false"
                            hide-details
                        />
                    </div>
                </div>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </v-expansion-panels>

    <draggable
        :disabled   = "!prioritize"
        :list       = "orders.display"
        style       = "overflow-y: scroll; margin-right: 4px;"
        :style      = "'max-height:' + scrollHeight + 'px'"
        ghost-class = "ghost"
    >
        <p-order-card
            v-for       = "(item, index) in orders.display"
            :order      = "item"
            :compact    = "compact"
            :prioritize = "prioritize"
            :background = "background(selected, item)"
            @selected   = "onSelected"
            @edit       = "onEdit"
            @remove     = "onRemove"
            :key        = "index"
            class       = "mb-1 mr-1"
            ref         = "order"
        />
    </draggable>
</div>
